module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('h6', [_vm._v("Shop Settings")]), _vm._v(" "), (_vm.menu_tab_view.manageBusiness) ? _c('div', [(_vm.sellpoint) ? _c('div', {
    staticStyle: {
      "text-align": "left",
      "height": "auto"
    }
  }, [_c('div', {
    staticClass: "menu-links-strip menu-links-strip-2"
  }, [_c('ul', [_c('a', {
    staticClass: "card-link",
    on: {
      "click": function($event) {
        _vm.setMenuTabViewLink('business', 'setBusinessProfile', _vm.sellpoint, '/account/business')
      }
    }
  }, [_c('li', [_vm._v("\r\n            Store Profile\r\n          ")])]), _vm._v(" "), _c('a', {
    staticClass: "card-link",
    on: {
      "click": function($event) {
        _vm.setMenuTabViewLink('business', 'setBusinessOrders', _vm.sellpoint, '/account/business/orders')
      }
    }
  }, [_c('li', [_vm._v("\r\n            Orders\r\n          ")])]), _vm._v(" "), _c('a', {
    staticClass: "card-link",
    on: {
      "click": function($event) {
        _vm.setMenuTabViewLink('business', 'setBusinessTransactions', _vm.sellpoint, '/account/business/transactions')
      }
    }
  }, [_c('li', [_vm._v("\r\n            Transactions\r\n          ")])]), _vm._v(" "), _c('a', {
    staticClass: "card-link",
    on: {
      "click": function($event) {
        _vm.setMenuTabViewLink('business', 'setBusinessShippingInformation', _vm.sellpoint, '/account/business/shipping')
      }
    }
  }, [_c('li', [_vm._v("\r\n            Shipping\r\n          ")])]), _vm._v(" "), _c('a', {
    staticClass: "card-link",
    on: {
      "click": function($event) {
        _vm.setMenuTabViewLink('business', 'setBusinessDiscountsCoupons', _vm.sellpoint, '/account/business/discounts')
      }
    }
  }, [_c('li', [_vm._v("\r\n            Discounts ")])]), _vm._v(" "), _c('a', {
    staticClass: "card-link",
    on: {
      "click": function($event) {
        _vm.setMenuTabViewLink('business', 'setBusinessPaymentInformation', _vm.sellpoint, '/account/business/payments')
      }
    }
  }, [_c('li', [_vm._v("\r\n            Payments\r\n          ")])]), _vm._v(" "), _c('a', {
    staticClass: "card-link",
    on: {
      "click": function($event) {
        _vm.setMenuTabViewLink('business', 'setBusinessRewards', _vm.sellpoint, '/account/business/rewards')
      }
    }
  }, [_c('li', [_vm._v("\r\n            Rewards\r\n          ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "card card-flat component-tabs"
  })]) : _vm._e()]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7ba4948e"}!./src/pages/Account/Sellpoint/Settings/template.html
// module id = 563
// module chunks = 0